export const pixionInfoEmail = 'info@pixion.co'
export const pixionContactEmail = 'info@pixion.co'
export const imageUrlRoot = process.env.NEXT_PUBLIC_STRAPI_API_URL
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
export const MAX_UPLOAD_FILES_NUMBER = 5
